module.exports = __webpack_public_path__ + "f55b2ffda82eaacee687da2fbf14fdf2.png";